import React from "react";
import { FiltersSelectedProps, useFilters, ClearAll } from "@usereactify/search";
import { FilterClearAll } from "./FilterClearAll";
import { FilterChevron } from "./FilterChevron";

export type FilterSelectedProps = React.ComponentProps<
  NonNullable<FiltersSelectedProps["render"]>
>;

export const FilterSelected: React.FC<FilterSelectedProps> = (
  props
) => {
 
  return (
    <div className="rs__filters-selected">
      <ul className="rs__filters-selected__list">
        {props.selectedFilters.map((selectedFilter) => (
          <FiltersSelectedItem
            selectedFilter={selectedFilter}
            handleRemove={props.handleRemove}
          />
        ))}

        <li className="rs__filter-clear-all">
          <ClearAll
            render={FilterClearAll}
          />
        </li>
      </ul>
    </div>
  );
};

type FilterSelectedPropsItemProps = {
  selectedFilter: FilterSelectedProps["selectedFilters"][number];
  handleRemove: FilterSelectedProps["handleRemove"];
};

const FiltersSelectedItem: React.FC<FilterSelectedPropsItemProps> = (
  props
) => {
  const filtersHook = useFilters();
  const filter = filtersHook.filters?.find(
    (filter) => filter.handle === props.selectedFilter.key
  );

  return (
    <li
      key={props.selectedFilter.key}
      className="rs__filters-selected__list-item"
    >
      <label className="rs__filters-selected__list-item-label">

        {filter?.displayType === "single" && filter.displayView === "range" && (
          <span className="rs__filters-selected__list-item-value">
            <span
              onClick={() =>
                props.handleRemove(props.selectedFilter.key, [
                  (props.selectedFilter.value as { label: string }).label,
                ])
              }
            >
              <span>
                {(props.selectedFilter.value as { label: string }).label}
              </span>

              <FilterChevron />
            </span>
          </span>
        )}
        {filter?.displayType === "single" && filter.displayView !== "range" && (
          <span className="rs__filters-selected__list-item-value">
            <span
              onClick={() =>
                props.handleRemove(props.selectedFilter.key, [
                  props.selectedFilter.value as string,
                ])
              }
            >
              <span>
                {props.selectedFilter.value as string}
              </span>

              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                  <g clip-path="url(#clip0_8771_2392)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.19133 0L8 0.808667L4.808 4L8 7.19133L7.19133 8L4 4.808L0.808667 8L0 7.19133L3.192 4L0 0.808667L0.808667 0L4 3.192L7.19133 0Z" fill="black" />
                  </g>
                  <defs>
                      <clipPath id="clip0_8771_2392">
                      <rect width="8" height="8" fill="white" />
                      </clipPath>
                  </defs>
                </svg>
              </span>
            </span>
          </span>
        )}
        {filter?.displayType === "multi" && filter.displayView === "range" && (
          <span className="rs__filters-selected__list-item-value">
            {(props.selectedFilter.value as Array<{ label: string }>).map(
              (value) => (
                <span
                  onClick={() =>
                    props.handleRemove(props.selectedFilter.key, [value.label])
                  }
                >
                  <span>
                    {value.label}
                  </span>
                  
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <g clip-path="url(#clip0_8771_2392)">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.19133 0L8 0.808667L4.808 4L8 7.19133L7.19133 8L4 4.808L0.808667 8L0 7.19133L3.192 4L0 0.808667L0.808667 0L4 3.192L7.19133 0Z" fill="black" />
                      </g>
                      <defs>
                          <clipPath id="clip0_8771_2392">
                          <rect width="8" height="8" fill="white" />
                          </clipPath>
                      </defs>
                    </svg>
                  </span>
                </span>
              )
            )}
          </span>
        )}
        {filter?.displayType === "multi" && filter.displayView !== "range" && (
          <span className="rs__filters-selected__list-item-value">
            {(props.selectedFilter.value as Array<string>).map((value) => (
              <span
                onClick={() =>
                  props.handleRemove(props.selectedFilter.key, [value])
                }
              >
                <span>
                  {value} 
                </span>
                
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <g clip-path="url(#clip0_8771_2392)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.19133 0L8 0.808667L4.808 4L8 7.19133L7.19133 8L4 4.808L0.808667 8L0 7.19133L3.192 4L0 0.808667L0.808667 0L4 3.192L7.19133 0Z" fill="black" />
                    </g>
                    <defs>
                        <clipPath id="clip0_8771_2392">
                        <rect width="8" height="8" fill="white" />
                        </clipPath>
                    </defs>
                  </svg>
                </span>
              </span>
            ))}
          </span>
        )}
        {filter?.displayType === "slider" && (
          <span className="rs__filters-selected__list-item-value">
            <span>
              {`${filter.displaySliderPrefix}${
                (props.selectedFilter.value as any)[0]
              } to ${filter.displaySliderPrefix}${
                (props.selectedFilter.value as any)[1]
              }`}
            </span>
          </span>
        )}
      </label>
    </li>
  );
};

